import { poppins } from "@/styles/font";
import { Flex, Text } from "@chakra-ui/react";
import Image from "next/image";
import emptyBox from '../../../public/no_product.png'

const EmptyBox = ({message} : {message: string}) => {
    return (
        <Flex
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            w={"full"}
            h={"full"}
            flexDirection={"column"}
        >
            <Image src={emptyBox} width={100} height={100} alt={""} />
            <Text className={poppins.className} textAlign={"center"} fontWeight={"semibold"} fontSize={'lg'}>{message}</Text>
        </Flex>
    )
}

export default EmptyBox;